import { AddableCourse, CourseLite } from "../../types/course.response";
import { ProgramSummaryResponse } from "../../types/program.response";
import { CourseRequirementOverride } from "../../services/api/user-courses.api";
import ChecklistSection from "./ChecklistSection";

interface ChecklistViewProps {
    program: ProgramSummaryResponse;
    handleAddCourse: (course: AddableCourse, overrides: CourseRequirementOverride[], semester: string | null, classSectionIds?: number[]) => void | Promise<void>;
    handleDeleteCourse: (course: CourseLite) => void | Promise<void>;
    handleOverride: (course: CourseLite, override: CourseRequirementOverride) => void | Promise<void>;
}

function OnboardingBanner() {
    return (
        <div className="flex items-start gap-2.5 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 mb-6">
            <svg className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <p className="text-sm text-blue-700">
                Add courses you've already taken to track your degree progress. Click any
                <span className="font-medium"> + Add completed course </span>
                row below to get started.
            </p>
        </div>
    );
}

export default function ChecklistView({
    program,
    handleAddCourse,
    handleDeleteCourse,
    handleOverride,
}: ChecklistViewProps) {
    const hasNoCourses = program.requirements.every(
        (r) => r.rootNode.summary.completedUnitsCount === 0
    );

    return (
        <div className="w-full">
            {hasNoCourses && <OnboardingBanner />}
            {program.requirements.map((requirement) => (
                <ChecklistSection
                    key={requirement.info.id}
                    requirement={requirement}
                    coursesMap={program.courses}
                    handleAddCourse={handleAddCourse}
                    handleDeleteCourse={handleDeleteCourse}
                    handleOverride={handleOverride}
                />
            ))}
        </div>
    );
}
